import { useStyletron } from '@thanx/uikit/theme'

import Badge from 'components/Badge'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'

const t = buildTranslate('components.ai.picker.canonical')

/** Marks a uid the merchant added though no version has it */
const NoMatchBadge = () => {
  const [css] = useStyletron()

  return (
    <Badge
      value={t('unmatched.badge')}
      className={`text-nowrap ${css({
        backgroundColor: palette.cayenne10,
        color: palette.cayenne50,
      })}`}
    />
  )
}

export default NoMatchBadge
